import { casesActions } from "configs";
import {
  useDispatch,
  useParams,
  useCurrentCase,
  setErrorsFromResponse
} from "duck";
import { useUpdateAdditionalDiagnosticTestMutation, Fragments } from "requests";

export const useUpdateAdditionalTest = () => {
  const dispatch = useDispatch();
  const shouldSync = useCurrentCase(medCase => medCase.shouldSync);

  const { id: caseId } = useParams();

  const [updateTest] = useUpdateAdditionalDiagnosticTestMutation({
    ignoreResults: true
  });

  return (newTest: Fragments.StoredAdditionalTests[number]) => {
    dispatch(casesActions.updateAdditionalTest({ _id: caseId, data: newTest }));

    if (shouldSync && newTest._id) {
      updateTest({
        variables: { input: { _id: newTest._id, toPerform: newTest.toPerform } }
      }).catch(error => {
        setErrorsFromResponse(error);
      });
    }
  };
};
